export enum BackgroundEnum {
    default = '',
    whiteBis = 'has-background-white-bis',
    whiteTer = 'has-background-white-ter',
    greyLighter = 'has-background-grey-lighter',
    greyLight = 'has-background-grey-light',
    grey = 'has-background-grey',
    greyDark = 'has-background-grey-dark',
    greyDarker = 'has-background-grey-darker',
    blackTer = 'has-background-black-ter',
    blackBis = 'has-background-black-bis',
    danger = 'has-background-danger',
    warning = 'has-background-warning',
    success = 'has-background-success',
    link = 'has-background-link',
    info = 'has-background-info',
    primary = 'has-background-primary',
    white = 'has-background-white',
    black = 'has-background-black',
    light = 'has-background-light',
    dark = 'has-background-dark',
}

export type Background = BackgroundEnum.default | BackgroundEnum.white | BackgroundEnum.whiteBis | BackgroundEnum.whiteTer |
    BackgroundEnum.greyLighter | BackgroundEnum.greyLight | BackgroundEnum.grey | BackgroundEnum.greyDark |
    BackgroundEnum.greyDarker | BackgroundEnum.blackTer | BackgroundEnum.blackBis | BackgroundEnum.danger |
    BackgroundEnum.warning | BackgroundEnum.success | BackgroundEnum.link |BackgroundEnum.info |
    BackgroundEnum.primary | BackgroundEnum.black |BackgroundEnum.light | BackgroundEnum.dark;


